var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalls = function SvgCalls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M51.099 65.182q-8.365 0-16.53-3.647-8.163-3.648-14.856-10.34-6.69-6.691-10.339-14.855-3.647-8.164-3.647-16.53 0-1.204.803-2.007Q7.334 17 8.538 17h10.84a2.5 2.5 0 0 1 1.674.636q.735.636.87 1.505l1.74 9.37q.134 1.07-.067 1.806t-.736 1.271l-6.492 6.559a32.4 32.4 0 0 0 3.18 4.784 47 47 0 0 0 4.048 4.45 47 47 0 0 0 4.35 3.848 42 42 0 0 0 4.818 3.246l6.29-6.29q.603-.603 1.573-.904a4.3 4.3 0 0 1 1.907-.167l9.235 1.873a3.1 3.1 0 0 1 1.539.97q.602.704.602 1.573v10.841q0 1.204-.803 2.008-.803.803-2.008.803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEBD9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M43.91 37A10.91 10.91 0 0 0 33 26.09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M53 37a20 20 0 0 0-20-20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M63 37A30 30 0 0 0 33 7"
  })));
};
export default SvgCalls;